"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WithoutPlayers = function (_a) {
    var emptyPlayers = _a.emptyPlayers, _b = _a.showWaitPlayers, showWaitPlayers = _b === void 0 ? true : _b;
    var t = (0, next_intl_1.useTranslations)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        emptyPlayers.map(function (item, idx) { return (react_1.default.createElement("div", { key: "empty_player_".concat(idx) },
            react_1.default.createElement("div", { style: { opacity: item.opacity } }, item.number),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.emptyPlayer, " ").concat(idx === 0 ? styles_module_scss_1.default.emptyPlayerFirstLine : ''), style: { width: "".concat(item.sizeName, "px"), opacity: item.opacity } })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.emptyPlayer, " ").concat(styles_module_scss_1.default.emptyPlayerRight, " ").concat(idx === 0 ? styles_module_scss_1.default.emptyPlayerFirstLine : ''), style: { width: "".concat(item.sizeResults, "px"), opacity: item.opacity } })))); }),
        showWaitPlayers && (react_1.default.createElement("div", { className: styles_module_scss_1.default.waitForPlayers },
            react_1.default.createElement("span", null, t('bestResults.tournament.waitForPlayers'))))));
};
exports.default = WithoutPlayers;
